import fetchTopicTree from './action-topic-list';
import getFaqList from './action-faq-list';


export default function getArticleListByTopic(topicSelected, experience) {
  return (dispatch, getState) => {
    const { topicList } = getState();
    if (topicList && topicList.topics && topicList.topics.length <= 0) {
      dispatch(fetchTopicTree(experience, topicSelected))
        .then((response) => {
          if (response && response.payload) {
            dispatch(getFaqList(response.payload, topicSelected));
          }
        });
    } else {
      dispatch(getFaqList(topicList, topicSelected));
    }
  };
}



// WEBPACK FOOTER //
// ./home/actions/actions-article-list.js